import React, { Fragment, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Row, Col, Nav, Tab, Dropdown, Modal } from "react-bootstrap";
import Card from "../../Card";
import { FiUser, FiCalendar, FiMoreVertical, FiPlus } from "react-icons/fi";

import {
  useSharedState,
  useGlobalState,
} from "../../../services/hostelConst.js";

import { getVehicle } from "../../../services/OrganisationServices/transportManagemetService";
import AddVehicleForm from "../../FormComponents/AddVehicleForm";

const TransportDetailsPage = () => {
  const [showAddTransportModal, setShowTransportModal] = useState(false);

  const [sharedState, setSharedState] = useSharedState();
  var { id } = useParams();
  console.log("id is for transport: ", id);
  const parms = useParams();
  const handleAddTransport = () => {
    setShowTransportModal(true);
  };

  const { toggleTransportMenu } = useGlobalState();
  const [transportDetails, setTransportDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [createdBy, setCreatedBy] = useState("loading...");
  const [createdOn, setCreatedOn] = useState("loading...");
  const [modifiedBy, setModifiedBy] = useState("loading...");
  const [activeKey, setActiveKey] = useState("first");

  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();

  useEffect(() => {
    setSharedState(true);
    toggleTransportMenu(true);
    const fetchTransportDetails = async () => {
      try {
        const response = await getVehicle(id);
        if (response.status === "success") {
          console.log("Transport details:", response.data);
          setCreatedBy(response.data["CREATED BY"]);
          setCreatedOn(response.data["CREATED ON"]);
          setModifiedBy(response.data["MODIFIED BY"]);

          setTransportDetails(response.data);
        }
      } catch (error) {
        console.error("Error fetching transport details:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchTransportDetails();
    }
  }, []);

  return (
    <Fragment>
      <Tab.Container activeKey={activeKey}>
        <Row>
          <Col lg="12">
            <Card>
              <Card.Body>
                <div className="row g-3">
                  <div className="col-9">
                    <div className="mb-4">
                      <h4 className="me-2 h4 mb-0">
                        {loading
                          ? "Loading..."
                          : transportDetails?.NAME || "Transport Details"}
                      </h4>
                    </div>
                    <div style={{ marginBottom: "6rem" }}></div>
                  </div>

                  <div className="col-3">
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center p-1  hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiUser className="text-primary fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Created By
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {createdBy}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Created On
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {createdOn}
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center p-1  hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiCalendar className="text-success fs-6" />
                        </div>
                        <div>
                          <small className="text-muted d-block">
                            Modified By
                          </small>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {modifiedBy}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center p-1 hover-bg-light rounded-2 small">
                        <div
                          className="bg-light rounded-circle p-1 me-2 d-flex align-items-center justify-content-center"
                          style={{ width: 28, height: 28 }}
                        >
                          <FiMoreVertical className="text-primary fs-6" />
                        </div>
                        <div>
                          <div
                            className="text-dark fw-medium"
                            style={{ fontSize: "0.875rem" }}
                          >
                            <Dropdown className="actions-dropdown">
                              <Dropdown.Toggle
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: "0",
                                  color: "#212529",
                                  boxShadow: "none",
                                }}
                              >
                                Actions
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="mt-2 py-1 rounded-3 shadow-lg border-0">
                                <Dropdown.Item
                                  className="d-flex align-items-center gap-2 px-3 py-2"
                                  onClick={handleAddTransport}
                                >
                                  <FiPlus className="text-primary" />
                                  Add Vehicle
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg="12">
            <Tab.Content className="profile-content">
              <Tab.Pane eventKey="first" id="profile-feed"></Tab.Pane>

              <Tab.Pane eventKey="third" id="profile-friends"></Tab.Pane>

              <Tab.Pane eventKey="fifth" id="profile-friends"></Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      <Modal
        show={showAddTransportModal}
        onHide={() => setShowTransportModal(false)}
        size="lg"
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-primary">Add Vehicle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddVehicleForm />
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default TransportDetailsPage;
